import type { IconSvgObject } from './types';

const CircleArrowExpand02Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "square", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 13L16.5 16.5M16.5 16.5L13 16.5M16.5 16.5L16.5 13M7.5 7.5L11 11M7.5 7.5L11 7.5M7.5 7.5L7.5 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleArrowExpand02Icon;
